import { Audio, Images, Tweens } from "@abcya/abcya_phaser";
import Gator from "../game/Gator";
import gameData from "../gameData";
import NavBar from "../ui/NavBar";
import UIAssetKeys from "../UIAssetKeys";

export default class TutorialScene extends Phaser.Scene
{
    static get KEY() { return 'TutorialScene'; }

    create()
    {
		this.bg = null;
		this.bg2 = null;
		this.bgCont = null;
		this.bgCont2 = null;

		this.gators = null;
		this.allGators = null;
		this.activeGators = null;
		this.navBar = null;
		this.next = null;

		this.arrow1 = null;

		this.stepper = 0;

		this.txt = null;
		this.txt2 = null;

		gameData.gameOver = false;
		gameData.gamePaused = false;
		gameData.currentScene = "TutorialScene";
		gameData.time = 60;
		gameData.score = 0;

		Audio.playOneShot("later_gator_jingle", this, .3, true);

		this.bg = Images.addImage(0, 0, UIAssetKeys._BackgroundLargerGutter, this).setOrigin(0);
		this.navBar = new NavBar(this);
		this.add.existing(this.navBar);

		//this.createGators();

		this.gators = [];
		this.allGators = [];
		this.activeGators = [];

		for(let g=0; g<=4; g+=4){
			let dir;
			if(g === 0 || g === 2 || g === 4){
				dir = "left";
			} else {
				dir = "right";
			}

			let gator = new Gator(this, dir, g);
			this.add.existing(gator);
			
			this.gators.push(gator);
			this.allGators.push(gator);
		}

		this.createPopup();
		this.createPopup2();
		

		this.arrow1 = this.add.sprite(250, 480, gameData.ss, "ArrowLEFT");
		this.arrow1.setOrigin(1, 0);
		this.arrow1.setScale(0, 0);
		this.arrow1.angle = 140;

		Tweens.addTween(this.arrow1, 1000, {scale:1, delay: 400}, Phaser.Math.Easing.Back.Out)
	}

	createPopup() {
		// console.log('pop 1')
		this.stepper++;

		this.bgCont = this.add.container();
		this.bg = Images.addImage(0, 0, UIAssetKeys._popupBG, this.bgCont).setOrigin(0);
		this.bg.setOrigin(.5, .5);
		const bgWidth = this.bg.getBounds().width;
		this.bgCont.setScale(0, 0);

		let txt;
		if(this.stepper === 1){
			txt = "1: Read the SUBJECT\n" +
				"in the gutter.";

			this.bg.setScale(.5, .6);
			this.bgCont.setPosition(bgWidth/4 + 40, this.scale.height/2 + 10);
		}
		else if(this.stepper === 3){
			txt = "Remember! Subjects\n" +
				"and verbs must agree.\n" +
				"\n" +
				"For example:\n" +
				"The girl runs\n" +
				"The girls run";

			this.bg.setScale(.6, .8);
			this.bgCont.setPosition(bgWidth/4 + 40, this.scale.height/2 - 10);
		}

		this.txt = this.add.bitmapText(-5, 0, 'font1', txt, 32);
		this.bgCont.add(this.txt);
		this.txt.setOrigin(.5, .5);
		this.txt.tint = 0x072f00;
		this.txt.align = 'center';
		this.txt.fontData.lineHeight = 60

		//this.cache.getBitmapFont('font1').font.lineHeight = 60;

		Tweens.addTween(this.bgCont, 1000, {scale:1}, Phaser.Math.Easing.Back.Out)
	};

	createPopup2() {
		this.stepper++;

		this.bgCont2 = this.add.container();
		this.bg2 = Images.addImage(0,  0, UIAssetKeys._popupBG, this.bgCont2).setOrigin(0);
		const bg2Width = this.bg2.getBounds().width;
		this.bg2.setOrigin(.5, .5);
		this.bgCont2.setScale(0, 0);

		var txt;
		if(this.stepper === 2){
			txt = "2: Click ONLY on the\n" +
				"verb that agrees\n" +
				"with that subject.";

			this.txt2 = this.add.bitmapText(-5, -60, 'font1', txt, 32);
			this.bgCont2.add(this.txt2);

			this.bg2.setScale(.6, .8);
			this.bgCont2.setPosition(bg2Width/4 + 60, this.scale.height/2 + 270);

			this.next = this.add.sprite(this.scale.width/2 + 100, this.scale.height - 70, gameData.ss, "PlayButton");
			this.next.setOrigin(.5, .5);
			this.next.setScale(0, 0);
			this.next.inputEnabled = true;

			//create small gator

			this.headCont = this.add.container();
			this.bgCont2.add(this.headCont);
	
			this.head = Images.addImage(0, 0, UIAssetKeys._HeadTop1, this.headCont).setOrigin(0);
			this.jaw = Images.addImage(0, 0, UIAssetKeys._LowerJaw1, this.headCont).setOrigin(0);
			this.sign = Images.addImage(0, 0, UIAssetKeys._sign, this.headCont).setOrigin(0);
			this.signTxt = this.add.bitmapText(200, 25, 'font1', "Run", 32);
			this.headCont.add(this.signTxt);
	
			this.head.setOrigin(.1, .2);
			this.jaw.setOrigin(.1, .5);
			this.sign.setOrigin(.5, 0);
			this.signTxt.setOrigin(.5,.5);
	
			this.head.setPosition(20, -50);
			this.jaw.setPosition(90, 5);
			this.sign.setPosition(200, -35);
			this.headCont.setPosition(-100, 60);
	
			this.headCont.setScale(.75, .75);
			this.signTxt.tint = "0x000000";

			Tweens.addTween(this.next, 1000, {scale:1, delay: 2000}, Phaser.Math.Easing.Back.Out,()=>{
				this.next.setInteractive();
				this.next.removeListener('pointerdown');
				this.next.on('pointerdown', ()=>this.tweenOutBubbles());
			});
			Tweens.addTween(this.bgCont2, 1000, {scale: 1, delay: 2000}, Phaser.Math.Easing.Back.Out);
		}
		else if(this.stepper === 4){
			txt = "Let's give it a try!\n" +
				"\n" +
				"Read the subject in\n" +
				"the gutter. Which\n" +
				"verb agrees?";

			this.txt2 = this.add.bitmapText(-5, 0, 'font1', txt, 32);
			this.bgCont2.add(this.txt2);

			this.bg2.setScale(.6, .7);
			this.bgCont2.setPosition(bg2Width/4 + 70, this.scale.height/2 + 290);

			Tweens.addTween(this.bgCont2, 1000, {scale: 1, delay: 2000}, Phaser.Math.Easing.Back.Out);

			this.tweenInGators();
		}

		this.txt2.setOrigin(.5, .5);
		this.txt2.tint = 0x072f00;
		this.txt2.align = 'center';
		//this.cache.getBitmapFont('font1').font.lineHeight = 60;
	};

	tweenOutBubbles() {
		this.next.disableInteractive();

		Tweens.addTween(this.next, 500, {x:0, y:0}, Phaser.Math.Easing.Back.In);
		Tweens.addTween(this.arrow1, 500, {x:0, y:0}, Phaser.Math.Easing.Back.In);
		Tweens.addTween(this.bgCont, 500, {x:0, y:0}, Phaser.Math.Easing.Back.In);
		Tweens.addTween(this.bgCont2, 500, {x:0, y:0}, Phaser.Math.Easing.Back.In, ()=>this.destroyBubbles());
	};

	destroyBubbles() {
		this.next.destroy();
		this.bgCont.destroy();
		this.bgCont2.destroy();

		this.createPopup();
		this.createPopup2();
	};

	tweenInGators() {
		this.time.addEvent({
			delay: 500,                
			callback: ()=>this.newGator()
		});
		this.time.addEvent({
			delay: 1200,                
			callback: ()=>this.newGator()
		});
	};

	newGator() {
		//ABCyaHelper.shuffleArray(this.gators);
		this.checkVerbs();
		this.gators[0].burstOut(true);
		this.activeGators.push(this.gators[0]);
		this.gators.shift();
	};

	checkVerbs() {
		if(gameData.rightAnswer === false){
			this.gators[0].changeText(gameData.nounType);
			this.gators[0].isCorrect = true;
			gameData.rightAnswer = true;
		} else {
			if(gameData.nounType === "singular"){
				this.gators[0].changeText("plural");
			} else {
				this.gators[0].changeText("singular");
			}
		}
	};

	allHide() {
		gameData.rightAnswer = false;

		for(var g=0; g<this.activeGators.length; g++){
			this.activeGators[g].hide();
			this.activeGators[g].isCorrect = false;
		}
	};

	cleanUp() {
		this.next.inputEnabled = false;

		this.stepper = 0;

		this.sound.stopAll();

		this.bg.destroy();
		this.bg2.destroy();
		this.next.destroy();
		this.arrow1.destroy();
		this.txt.destroy();
		this.txt2.destroy();
		this.bgCont.destroy();
		this.bgCont2.destroy();

		this.navBar.cleanUp();
		this.navBar.destroy();

		this.scene.start("PlayScene");
	};
}

/*

	me.

	me.

	me.

	me.goToGame() {
		this.txt.text = "Your city needs\n" +
			"your help!\n" +
			"\n" +
			"Think fast...and\n" +
			"save your city!\n" +
			"\n" +
			"\n" +
			"\n";

		this.next = Images.addImage(0,  90, UIAssetKeys._NextButton, this.bgCont).setOrigin(0);
		this.next.setOrigin(.5, .5);
		this.next.setScale(0, 0);
		this.next.inputEnabled = true;

		game.add.tween(this.next.scale).to({x:1, y:1}, 500, Phaser.Math.Easing.Back.Out, true)
			.onComplete.addOnce(function(){enableUserClick(this.next, this.cleanUp, this)}, this);
		game.add.tween(this.arrow1.scale).to({x:0, y:0}, 500, Phaser.Math.Easing.Back.In, true);
		game.add.tween(this.arrow2.scale).to({x:0, y:0}, 500, Phaser.Math.Easing.Back.In, true, 200);
	};

	me.
})();*/